import React from 'react';
import * as S from '../../CancelFlow/NoRefundCancelPop/NoRefundCancelPop.styles';
import IconSelector from '@ibibo/icon-selector';

const NoRefundCancelPop = ({confirmReschedule, closeModal}) => {
    return(
      <S.CofirmPopOuterWrap>
        <S.ConfirmPopInnerWrap>
            <S.CofirmPopHeadText>Are you sure you want to Proceed?</S.CofirmPopHeadText>
            <S.ConfirmInfoText>Please confirm modification to modify your hotel booking</S.ConfirmInfoText>
        </S.ConfirmPopInnerWrap>
        <S.ConfirmPopBtnWrap>
          <S.BackButtonWrap onClick={closeModal}>
            <S.BackButton>Cancel</S.BackButton>
          </S.BackButtonWrap>
          <S.ConfirmCancelBtn onClick={confirmReschedule}>Confirm</S.ConfirmCancelBtn>
        </S.ConfirmPopBtnWrap>
    </S.CofirmPopOuterWrap>
    );
}

export default NoRefundCancelPop;